import React from "react";
import Breadcrumb from "../../../common/Breadcrumb";
import BlogStandardWrap from "./BlogStandardWrap";

function BlogStandard() {
  return (
    <>
      <Breadcrumb name="Blog Standard" />
      <BlogStandardWrap />
    </>
  );
}

export default BlogStandard;
